<template>
    <div>
        <img
            class="mr-sm lg:mr-md"
            style="cursor: zoom-in; height: auto;"
            :src="thumbSrc"
            @click="$modal.show(modalName)"
        >
        <adaptive-modal
            :hide-action-buttons="true"
            :name="modalName"
            :title="title"
            :width="width"
        >
            <div
                style="text-align: center;"
            >
                <img
                    :src="originalSrc"
                >
            </div>
        </adaptive-modal>
    </div>
</template>

<script>
    export default {
        props: {
            imageFileId: {
                type: String,
                default: '',
            },
            originalSrc: {
                type: String,
                default: '',
            },
            thumbSrc: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: 'Förhandsgranskning',
            },
        },

        data() {
            return {
                randomId: Math.round(Math.random() * 1000),
            };
        },

        computed: {
            modalName() {
                return `image-preview-${this.imageFileId}-${this.randomId}`;
            },
            width() {
                return window.innerWidth <= 600 ? (window.innerWidth - 100) : Math.round(Math.max(window.innerWidth * .6, 600));
            },
        },
    };
</script>
